// NoobSync Brand Ambassador referral capture.
// Reads ?ref=NSA-XXXX from the URL on landing and persists it for 30 days (cookie +
// localStorage) so the code survives across pages until the user registers/pays.
// The actual API call to the ambassador platform happens server-side (backend proxy)
// to keep the API key secret.
const KEY = "ns_ref";
const THIRTY_DAYS_S = 30 * 24 * 60 * 60;

const readCookie = (name) => {
  try {
    const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  } catch (e) {
    return null;
  }
};

export const captureReferral = () => {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && /^NSA-/.test(ref.trim())) {
      const code = ref.trim();
      document.cookie = `${KEY}=${encodeURIComponent(code)}; path=/; max-age=${THIRTY_DAYS_S}; SameSite=Lax`;
      localStorage.setItem(KEY, code);
    }
  } catch (e) {
    console.error("captureReferral failed:", e);
  }
};

export const getReferral = () => {
  try {
    return localStorage.getItem(KEY) || readCookie(KEY) || null;
  } catch (e) {
    console.error("getReferral failed:", e);
    return null;
  }
};

export const clearReferral = () => {
  try {
    localStorage.removeItem(KEY);
    document.cookie = `${KEY}=; path=/; max-age=0; SameSite=Lax`;
  } catch (e) {
    console.error("clearReferral failed:", e);
  }
};
